import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | Vivcloud Technologies</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <section className="min-h-[70vh] flex items-center justify-center bg-[#f8f9fe] px-5">
        <div className="text-center max-w-md">
          <p
            className="text-8xl font-black mb-4"
            style={{
              background: "linear-gradient(135deg,#5b6ef5,#00b4d8)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            404
          </p>
          <h1 className="text-2xl font-extrabold text-slate-900 mb-3">
            Page Not Found
          </h1>
          <p className="text-slate-500 text-sm mb-8 leading-relaxed">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="flex flex-wrap gap-3 justify-center">
            <Link to="/" className="btn-primary">
              Back to Home
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </Link>
            <Link to="/contact" className="btn-outline">
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFound;
